import styled, { css } from 'styled-components';
import type { Box } from './sketch/sketchLayout';

export const FillingRoot = styled.div`
  padding: 12px 8px;

  ${({ theme: { colors } }) => css`
    background-image: radial-gradient(${colors.outlineVariant} 1px, transparent 1px);
    background-size: 24px 24px;
  `}
`;

export const SketchFrame = styled.div`
  position: relative;
`;

export const SketchArea = styled.svg`
  display: block;
  width: 100%;
  height: auto;
`;

const percent = (part: number, whole: number) => `${(part / whole) * 100}%`;

// Placed in the drawing's own units, so the buddy sits on the thumbnail it draws.
export const Home = styled.div<{ readonly $box: Box; readonly $width: number; readonly $height: number }>`
  position: absolute;
  display: grid;
  place-items: center;
  pointer-events: none;
  ${({ $box, $width, $height }) => css`
    left: ${percent($box.x, $width)};
    top: ${percent($box.y, $height)};
    width: ${percent($box.w, $width)};
    height: ${percent($box.h, $height)};
  `}
`;
